export const SHOW_BUY_RATNA_MODAL = 'SHOW_BUY_RATNA_MODAL';
export const HIDE_BUY_RATNA_MODAL = 'HIDE_BUY_RATNA_MODAL';
export const SET_BETA_USER_STATUS = 'SET_BETA_USER_STATUS';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_USER_PROFILE_DATA = 'SET_USER_PROFILE_DATA';
export const SET_DISCOUNT_TEMPLATES_DATA = 'SET_DISCOUNT_TEMPLATES_DATA';
export const SET_COMMISSION_TIER_DATA = 'SET_COMMISSION_TIER_DATA';
export const SET_CONNECTED_EMAILS_DATA = 'SET_CONNECTED_EMAILS_DATA';
export const SET_TAGS_DATA = 'SET_TAGS_DATA';
export const SHOW_CONDITIONAL_RATNA_WON_MODAL = 'SHOW_CONDITIONAL_RATNA_WON_MODAL';
export const CLOSE_CONDITIONAL_RATNA_WON_MODAL = 'CLOSE_CONDITIONAL_RATNA_WON_MODAL';
export const SET_USER_SETTINGS_DATA = 'SET_USER_SETTINGS_DATA';
export const SET_INBOUND_EMAIL_TEMPLATES_DATA = 'SET_INBOUND_EMAIL_TEMPLATES_DATA';
export const UPDATE_USER_INBOUND_EMAIL_TEMPLATES_OPTIMISTICALLY = 'UPDATE_USER_INBOUND_EMAIL_TEMPLATES_OPTIMISTICALLY';
export const SET_SUBSCRIPTION_STATUS = 'SET_SUBSCRIPTION_STATUS';
export const USER_LOGOUT = 'USER_LOGOUT';
export const UPDATE_DOWNTIME_BANNER = 'UPDATE_DOWNTIME_BANNER';
export const SET_MULTI_USER_ACCESS = 'SET_MULTI_USER_ACCESS';
export const SET_TEAM_MEMBER_ID = 'SET_TEAM_MEMBER_ID';
export const SET_BUY_RATNA_MODAL_LEFT_SECTION = 'SET_BUY_RATNA_MODAL_LEFT_SECTION';
export const UPDATE_PARTNERSHIP_LIMIT_REACHED = 'UPDATE_PARTNERSHIP_LIMIT_REACHED';
export const SET_MULTI_BRAND_ACCOUNTS = 'SET_MULTI_BRAND_ACCOUNTS';
